import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";

import { cn } from "@/src/js/lib/utils";

function Switch({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        // Preflight is off, so the border and padding a button starts with are reset here
        "tw:peer tw:inline-flex tw:h-5 tw:w-9 tw:shrink-0 tw:cursor-pointer tw:items-center tw:rounded-full tw:border-0 tw:p-0 tw:shadow-xs tw:transition-all tw:outline-none tw:focus-visible:ring-[3px] tw:focus-visible:ring-neutral-950/50 tw:disabled:cursor-not-allowed tw:disabled:opacity-50 tw:data-[state=checked]:bg-neutral-900 tw:data-[state=unchecked]:bg-neutral-300",
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className="tw:pointer-events-none tw:block tw:size-4 tw:rounded-full tw:bg-white tw:ring-0 tw:transition-transform tw:data-[state=checked]:translate-x-[18px] tw:data-[state=unchecked]:translate-x-0.5"
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
